<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <div *ngIf="percentage">
    <mat-spinner class="spinner-center" style="z-index: 1000;" aria-label="Rating">
    </mat-spinner>
    <div class="spinner-center" style="z-index: 1000; font-size: x-large;">{{ percentage | number : '1.0-1' }} %</div>
  </div>
  <mat-spinner *ngIf="!percentage" class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>


<div mat-dialog-title>
  {{ modalData.title }}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography">
  <div class="form-group row mt-1">
    <label class="col-3 col-form-label">ประเภทคำถาม<lifedi-require></lifedi-require></label>
    <div class="col-9">
      <select class="custom-select form-control" style="display: inline;" (change)="setType($event)" [(ngModel)]="type">
        <option selected disabled hidden>เลือกประเภท</option>
        <option *ngFor="let t of questionType" [value]="t.value">{{ t.name }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="!modalData.isEdit">
    <div *ngIf="type === 'multi_choice'" class="mb-2">
      <div [formGroup]="multipleChoiceForm">
        <lifedi-question-multiple-choice [multipleChoiceForm]="multipleChoiceForm" (media)="getChoicesMedia($event)"
          (qMedia)="getQuestionMedia($event)" (qMediaType)="getQuestionMediaType($event)" [isEditValue]="false">
        </lifedi-question-multiple-choice>
      </div>
    </div>

    <div *ngIf="type === 'rating'" class="mb-2">
      <div [formGroup]="ratingForm">
        <lifedi-question-rating [ratingForm]="ratingForm" [isEditValue]="false"></lifedi-question-rating>
      </div>
    </div>

    <div *ngIf="type === 'ranking'" class="mb-2">
      <div [formGroup]="rankingForm">
        <lifedi-question-ranking [rankingForm]="rankingForm" [isEditValue]="false"></lifedi-question-ranking>
      </div>
    </div>

    <div *ngIf="type === 'most/least'" class="mb-2">
      <div [formGroup]="mostLeastForm">
        <lifedi-question-most-least [mostLeastForm]="mostLeastForm" (qMedia)="getQuestionMedia($event)"
          (qMediaType)="getQuestionMediaType($event)" [isEditValue]="false"></lifedi-question-most-least>
      </div>
    </div>

    <div *ngIf="type === 'multi'" class="mb-2">
      <div [formGroup]="multiForm" class="mt-1">
        <lifedi-question-multi [form]="multiForm" [isEditValue]="false">
        </lifedi-question-multi>
      </div>
    </div>
  </div>

  <div *ngIf="modalData.isEdit">
    <div *ngIf="type === 'multi_choice'" class="mb-2">
      <div [formGroup]="multipleChoiceForm">
        <lifedi-question-multiple-choice [multipleChoiceForm]="multipleChoiceForm" (media)="getChoicesMedia($event)"
          (qMedia)="getQuestionMedia($event)" (qMediaType)="getQuestionMediaType($event)" [isEditValue]="true">
        </lifedi-question-multiple-choice>
      </div>
    </div>

    <div *ngIf="type === 'rating'" class="mb-2">
      <div [formGroup]="ratingForm">
        <lifedi-question-rating [ratingForm]="ratingForm" [isEditValue]="true"></lifedi-question-rating>
      </div>
    </div>

    <div *ngIf="type === 'ranking'" class="mb-2">
      <div [formGroup]="rankingForm">
        <lifedi-question-ranking [rankingForm]="rankingForm" [isEditValue]="true"></lifedi-question-ranking>
      </div>
    </div>

    <div *ngIf="type === 'most/least'" class="mb-2">
      <div [formGroup]="rankingForm">
        <lifedi-question-most-least [mostLeastForm]="mostLeastForm" (qMedia)="getQuestionMedia($event)"
          (qMediaType)="getQuestionMediaType($event)" [isEditValue]="true"></lifedi-question-most-least>
      </div>
    </div>
  </div>

</mat-dialog-content>

<p *ngIf="isEdit" class="text-center text-danger" style="margin: 0 0 -10px;">
  <small>เมื่อกดบันทึก ข้อมูลจะเข้าระบบทันที</small>
</p>

<mat-dialog-actions *ngIf="!modalData.isEdit" align="center">
  <button *ngIf="multipleChoiceForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addQuastionList(multipleChoiceForm, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="ratingForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addQuastionList(ratingForm, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="rankingForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addQuastionList(rankingForm, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="mostLeastForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addQuastionList(mostLeastForm, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="multiForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="addQuastionList(mostLeastForm, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button
    *ngIf="!multipleChoiceForm.valid && !ratingForm.valid && !rankingForm.valid && !mostLeastForm.valid && !multiForm.valid"
    mat-button disabled="true">
    {{ modalData.actionBtnText }}
  </button>
</mat-dialog-actions>

<mat-dialog-actions *ngIf="modalData.isEdit" align="center">
  <button *ngIf="type === 'multi_choice' && multipleChoiceForm.valid" mat-button
    style="background: #3E8C1A; color: #fff;" (click)="editQuestionList(multipleChoiceForm, true)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="type === 'rating' && ratingForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="editQuestionList(ratingForm, true)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="type === 'ranking' && rankingForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="editQuestionList(rankingForm, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="type === 'most/least' && mostLeastForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="editQuestionList(mostLeastForm, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="type === 'multi' && multiForm.valid" mat-button style="background: #3E8C1A; color: #fff;"
    (click)="editQuestionList(mostLeastForm, false)">
    {{ modalData.actionBtnText }}
  </button>
  <button
    *ngIf="!multipleChoiceForm.valid && !ratingForm.valid && !rankingForm.valid && !mostLeastForm.valid && !multiForm.valid"
    mat-button disabled="true">
    {{ modalData.actionBtnText }}
  </button>
</mat-dialog-actions>
